import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const AddonSheet = ApplicationRecord.extend({
  static: {
    jsonapiType: 'addon_sheets',
  },
  attrs: {
    addonId: attr(),
    orderPackageId: attr(),
    index: attr(),
    foreground: belongsTo(),
    foregroundId: attr(),
    hasDownloadableImage: attr({ persist: false }),
    seniorImageId: attr(),
    poseId: attr(),
    backgroundId: attr(),
    studentImageId: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    orderPackage: belongsTo(),
    addon: belongsTo(),
    pose: belongsTo(),
    background: belongsTo(),
    seniorImage: belongsTo(),
    studentImage: belongsTo(),
  },
})

export default AddonSheet
